module.exports = __webpack_public_path__ + "img/social_media-facebook.3eba737b.svg";